import { render, staticRenderFns } from "./wechatdialog.vue?vue&type=template&id=0bbeadb0&scoped=true"
import script from "./wechatdialog.vue?vue&type=script&lang=js"
export * from "./wechatdialog.vue?vue&type=script&lang=js"
import style0 from "./wechatdialog.vue?vue&type=style&index=0&id=0bbeadb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbeadb0",
  null
  
)

export default component.exports